import { useTranslation } from 'react-i18next'

import { allLangs, defaultLang } from './langConfig'
import { changeAllLanguages } from './languageSync'

export const useLocales = () => {
  const { i18n, t } = useTranslation()

  const primaryLangCode = i18n.language
  const currentLang =
    allLangs.find((_lang) => _lang.value === primaryLangCode) ?? defaultLang

  const onChangeLang = async (newLang: string) => {
    await changeAllLanguages(newLang)
  }

  return {
    onChangeLang,
    t,
    currentLang,
    allLangs
  }
}
